export function getValueByKeyPath(target: any, path: string) {
  return path.split('.').reduce((previous, current) => previous[current], target);
}
